<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('sys_micro_config')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <sys-micro-config-modal ref="modalForm" @ok="modalFormOk"></sys-micro-config-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SysMicroConfigModal from './modules/SysMicroConfigModal'

  export default {
    name: 'SysMicroConfigList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      SysMicroConfigModal
    },
    data () {
      return {
        description: 'sys_micro_config管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'name',
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'entry',
            align:"center",
            dataIndex: 'entry'
          },
          {
            title:'container',
            align:"center",
            dataIndex: 'container'
          },
          {
            title:'activeRule',
            align:"center",
            dataIndex: 'activeRule'
          },
          {
            title:'code',
            align:"center",
            dataIndex: 'code'
          },
          {
            title:'百度统计标识',
            align:"center",
            dataIndex: 'baiduStatFlag'
          },
          {
            title:'百度统计key',
            align:"center",
            dataIndex: 'baiduStatKey'
          },
          {
            title:'desc',
            align:"center",
            dataIndex: 'desc'
          },
          {
            title:'status',
            align:"center",
            dataIndex: 'status'
          },
          {
            title:'sortNo',
            align:"center",
            dataIndex: 'sortNo'
          },
          {
            title:'刪除标示',
            align:"center",
            dataIndex: 'delFlag'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/sys/microconf/sysmicroconfigs",
          delete: "/sys/microconf/sysmicroconfig",
          deleteBatch: "/sys/microconf/sysmicroconfig/batch",
          exportXlsUrl: "/sys/microconf/export-xls",
          importExcelUrl: "sys/microconf/import-excel",
          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'name',text:'name'})
        fieldList.push({type:'string',value:'entry',text:'entry'})
        fieldList.push({type:'string',value:'container',text:'container'})
        fieldList.push({type:'string',value:'activeRule',text:'activeRule'})
        fieldList.push({type:'string',value:'code',text:'code'})
        fieldList.push({type:'string',value:'baiduStatFlag',text:'百度统计标识'})
        fieldList.push({type:'string',value:'baiduStatKey',text:'百度统计key'})
        fieldList.push({type:'string',value:'description',text:'description'})
        fieldList.push({type:'string',value:'status',text:'status'})
        fieldList.push({type:'int',value:'sortNo',text:'sortNo'})
        fieldList.push({type:'string',value:'delFlag',text:'刪除标示'})
        fieldList.push({type:'string',value:'remark',text:'备注'})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
